export default __webpack_public_path__ + "static/media/document.2ee11ec1.svg";